export default __webpack_public_path__ + "static/media/Report.94c26194.svg";